import { onBeforeUnmount } from 'vue'

let broadcastChannel = null

const useBroadcastChannel = () => {
  if (!broadcastChannel) {
    broadcastChannel = new BroadcastChannel('app-channel')
  }

  const sendMessage = (action, payload = {}) => {
    if (broadcastChannel) {
      broadcastChannel.postMessage({ action, payload })
    }
  }

  const setupBroadcastChannel = (onMessageCallback) => {
    if (broadcastChannel) {
      broadcastChannel.onmessage = (event) => {
        const { action, payload } = event.data
        if (onMessageCallback) {
          onMessageCallback(action, payload)
        }
      }
    }
  }

  const closeChannel = () => {
    if (broadcastChannel) {
      broadcastChannel.close()
      broadcastChannel = null
    }
  }

  onBeforeUnmount(() => {
    closeChannel()
  })

  return { sendMessage, setupBroadcastChannel, closeChannel }
}

export default useBroadcastChannel
